import rfdc from "rfdc";
import moment from 'moment';

const cloneDeep = rfdc();

// transform data to provide table
export const transformDataPeriodicities = (pData: any[]) => {
  let newData: object[] = [];
  pData.forEach((periode) => {
    newData.push({
      code: '',
      name: periode.month + ' - ' + periode.year,
      year: periode.year,
      monthId: periode.monthId,
    });
  });
  return newData;
};

// create a row for events table
export const createRows = (pEvents: object[]) => {
  let datas: any[] = [];
  pEvents.forEach((line: any) => {
    datas.push({
      id: line.id,
      mainInstallCode: line.mainInstallCode,
      curveNumber: line.curveNumber,
      startDate: moment.utc(line.startDate).format('DD/MM/YYYY'),
      endDate: moment.utc(line.endDate).format('DD/MM/YYYY'),
      dumpedVolume: line.dumpedVolume,
      dumpedTreshold: line.dumpedTreshold,
      startDateForRequest: line.startDate,
      endDateForRequest: line.endDate,
      selected: false,
    });
  });
  return datas;
};

// update data table
export const updateEventsTable = (pEvent: any, pDataTable: any[], pRow: any) => {
  // if necessary don't use cloning array
  // duplicate array
  let dataTableUpdated = cloneDeep(pDataTable);
  // get row
  let rowToUpdate = dataTableUpdated.find(
    (line) => line.id === pRow.original.id
  );
  // get id row
  let idRowToUpdate = dataTableUpdated.findIndex(
    (line) => line.id === pRow.original.id
  );
  // create new version
  const newDataTable = dataTableUpdated.map((c, i) => {
    if (i === idRowToUpdate) {
      rowToUpdate.selected = pEvent.currentTarget.checked;
      return rowToUpdate;
    } else {
      return c;
    }
  });
  return newDataTable;
};

export const prepareDataForGraphics = (pData: any[]) => {
  let dataFormated: any[] = [];
  pData.forEach((d: any) => {
    dataFormated.push({
      x: new Date(d.time),
      y: d.v,
    });
  });
  return dataFormated;
};

// get unique date of array
export const prepareDatesPoints = (pData: any[]) => {
  const datePointsFormated: any[] = [];
  const map = new Map();
  pData.forEach((item) => {
    const dateItem = new Date(item.time);
    if (!map.has(dateItem.getDate())) {
      map.set(dateItem.getDate(), true); // set any value to Map
      datePointsFormated.push({
        x: dateItem,
        y: item.v,
      });
    }
  });
  return datePointsFormated;
};

// create points for tresholds
export const defineTresholds = (pCumulativeRain: any[]) => {
  let tresholds: any[] = [];
  const nextToDeversements = pCumulativeRain.filter(
    (rain: any) => rain.y === 0
  );
  nextToDeversements.forEach((p) => {
    // warning !!! 23h and 24h have the same date with 23h
    let index = pCumulativeRain.findIndex((i) => (i.x === p.x) && (i.y === 0));
    // avoid first element of cumulativeRain and if two events who follow each others whith y is equal to 0
    if (pCumulativeRain[index - 1] && pCumulativeRain[index - 1].y !== 0) {
      tresholds.push(pCumulativeRain[index - 1]);
    }
  });
  return tresholds;
};

// get max value for vertical line
export const getMaxValue = (pCumulativeRain: any[]) => {
  // get max value
  let getValues: number[] = [];
  pCumulativeRain.forEach((value) => {
    getValues.push(Math.round(value.y));
  });
  getValues.sort(function (a, b) {
    return a - b;
  });
  return getValues[getValues.length - 1];
};

// define points to create verticals lines
export const defineVerticalLines = (pCumulativeRain: any[], pDeversement: any[]) => {
  let verticalLinesParams: any[] = [];

  // get max value
  const maxValue = getMaxValue(pCumulativeRain);

  // add max value
  pDeversement.forEach((dev) => {
    let verticalLineParams = [
      { x: dev.x, y: 0 },
      { x: dev.x, y: maxValue },
    ];
    verticalLinesParams.push(verticalLineParams);
  });
  return verticalLinesParams;
};